module.exports = __webpack_public_path__ + "static/media/2_online.a25afb22.png";